
import React, { useState } from 'react';
import CPDForm from './components/CPDForm';
import CPDTable from './components/CPDTable';

import { Document, Packer, Paragraph, TextRun, Table, TableCell, TableRow, } from 'docx';
import './App.css'; // Import the CSS file

const App = () => {
  const [records, setRecords] = useState([]);
  const sortedRecords = records.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

  const addCPDRecord = (record) => {
    setRecords((prevRecords) => [...prevRecords, record]);
  };




  const generateWord = async () => {
    const headerRow = [
      new TableCell({ children: [new Paragraph({ text: "Title", bold: true })] }),
      new TableCell({ children: [new Paragraph({ text: "Duration (hrs)", bold: true })] }),
      new TableCell({ children: [new Paragraph({ text: "Start Date", bold: true })] }),
      new TableCell({ children: [new Paragraph({ text: "End Date", bold: true })] }),
      new TableCell({ children: [new Paragraph({ text: "Venue", bold: true })] }),
      new TableCell({ children: [new Paragraph({ text: "Organized By", bold: true })] }),
      new TableCell({ children: [new Paragraph({ text: "Conducted By", bold: true })] }),
      new TableCell({ children: [new Paragraph({ text: "CPD Type", bold: true })] }),
    ];

    const tableRows = sortedRecords.map(record => {
      return new TableRow({
        children: [
          new TableCell({ children: [new Paragraph(record.title)] }),
          new TableCell({ children: [new Paragraph(record.duration.toString())] }),
          new TableCell({ children: [new Paragraph(new Date(record.startDate).toLocaleDateString())] }),
          new TableCell({ children: [new Paragraph(record.endDate ? new Date(record.endDate).toLocaleDateString() : new Date(record.startDate).toLocaleDateString())] }),
          new TableCell({ children: [new Paragraph(record.venue)] }),
          new TableCell({ children: [new Paragraph(record.organizedBy)] }),
          new TableCell({ children: [new Paragraph(record.conductedBy)] }),
          new TableCell({ children: [new Paragraph(record.cpdType)] }),
        ],
      });
    });

    const table = new Table({
      rows: [new TableRow({ children: headerRow }), ...tableRows],
    });

    const doc = new Document({
      sections: [{
        properties: {},
        children: [
          new Paragraph({
            children: [
              new TextRun({
                text: 'Continuous Professional Development',
                bold: true,
                size: 32,
              }),
            ],
          }),
          new Paragraph(''), // Add a blank line
          table // Add the table here
        ],
      }],
    });

    

    const blob = await Packer.toBlob(doc);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'cpd_records.docx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className='test'>
  <CPDForm addCPDRecord={addCPDRecord} />
  {records.length > 0 ? (
    <div>
  <div>
    <h2 align='center'>Continuing Professional Development</h2>
  </div>
  
    <div className="table-container">
      <CPDTable records={sortedRecords} />
      <div className='button-1'>
        {/* <button onClick={generatePDF}>Download as PDF</button> */}
        <button onClick={generateWord}>Download as Word</button>
      </div>
    </div> </div>
  ) : (
    <div align='center'>
      {/* <h2>No records available. Please add a record to continue.</h2> */}
    </div>
  )}
</div>
 
  );
};

export default App;
